import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class FabricantedeService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    create(data: any)  {
        return this.http.post(`${SCAMP_API.accountApiV1}/fabricante`, data, {headers : this.account.composeHeaders()});
    }

    read(id: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/fabricante/${id}`, {headers : this.account.composeHeaders()});
    }

    update(id: number, data: any) {
        return this.http.put(`${SCAMP_API.accountApiV1}/fabricante/${id}`, data, {headers : this.account.composeHeaders()});
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/fabricante/${id}`, {headers : this.account.composeHeaders()});
    }

    list(): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/fabricantes`, {headers : this.account.composeHeaders()});
    }

    isUniqueNomeFabricante(nome: string): Observable<boolean> {
        return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/nome-fabricante-is-unique`, {nome},
        {headers : this.account.composeHeaders()});
    }
}
